export class RealtimeConnection {
    constructor(
        readonly contextId: number,
        readonly connection: signalR.HubConnection,
    ) {}

    public closedPermanently: boolean;
    public onRegisterEvents: (RealtimeConnection) => void;
    public onDetachEvents: (RealtimeConnection) => void;
}
